import { useCacheStore } from '@/stores/cache-store'

/**
 * Tüm cache'i temizler
 */
export const clear = () => {
  const cacheStore = useCacheStore()
  cacheStore.clear()
  
  // İstatistik için
  if (typeof window !== 'undefined' && window.__CACHE_STATS__) {
    window.__CACHE_STATS__.invalidations = (window.__CACHE_STATS__.invalidations || 0) + 1
  }
  
  if (process.env.NODE_ENV === 'development') {
    console.log('🧹 Cache CLEAR: Tüm cache temizlendi')
  }
}